import { GetJobRatingStatusResponse } from '@taxfyle/api-internal/internal/job_rating_pb'

export const allRatingStatuses = [
  'Disabled',
  'Pending',
  'Rated',
  'NotReady',
  'NotApplicable',
  'Unknown',
] as const

export type RatingStatus = (typeof allRatingStatuses)[number]

export interface JobRatingStatus {
  proRating: RatingStatus
  platformRating: RatingStatus
}

export function mapRatingStatusProtoToRatingStatus(
  status: GetJobRatingStatusResponse.Status,
): RatingStatus {
  switch (status) {
    case GetJobRatingStatusResponse.Status.PENDING:
      return 'Pending'
    case GetJobRatingStatusResponse.Status.NOT_READY:
      return 'NotReady'
    case GetJobRatingStatusResponse.Status.RATED:
      return 'Rated'
    case GetJobRatingStatusResponse.Status.DISABLED:
      return 'Disabled'
    case GetJobRatingStatusResponse.Status.NOT_APPLICABLE:
      return 'NotApplicable'
  }
  // The API may send values this build doesn't know yet.
  return 'Unknown'
}

export function mapJobRatingStatusProtoToProps(
  proto: GetJobRatingStatusResponse,
): JobRatingStatus {
  return {
    proRating: mapRatingStatusProtoToRatingStatus(proto.getProRating()),
    platformRating: mapRatingStatusProtoToRatingStatus(
      proto.getPlatformRating(),
    ),
  }
}
